export default "__VITE_ASSET__DasDIndR__"